/** Swell rswEXIT — ERC-721 enumerable withdrawal NFT for rswETH.
 *  Address on chain 1: `0x58749c46FfE97e4d79508a2c781C440f4756f064`.
 *
 *  Verified via on-chain `supportsInterface(0x780e9d63) → true`
 *  (ERC721Enumerable). The contract inherits `ERC721EnumerableUpgradeable`
 *  from the Swell v3-core implementation.
 *
 *  Per-id detail is `getWithdrawalRequest(tokenId) → WithdrawRequest`
 *  with `(amount, timestamp, lastTokenIdProcessed, rateWhenCreated)`.
 *  A request is claimable iff `tokenId <= getLastTokenIdProcessed()`. */
export const SwellRswExitAbi = [
  {
    name: 'balanceOf',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'tokenOfOwnerByIndex',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address' }, { type: 'uint256' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'getWithdrawalRequest',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'tokenId' }],
    outputs: [
      {
        type: 'tuple',
        components: [
          { type: 'uint256', name: 'amount' },
          { type: 'uint256', name: 'timestamp' },
          { type: 'uint256', name: 'lastTokenIdProcessed' },
          { type: 'uint256', name: 'rateWhenCreated' },
        ],
      },
    ],
  },
  {
    name: 'getLastTokenIdProcessed',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
